<div class="main-into-container">
  <div class="background-img-snow"></div>
  <div class="decorator"></div>
  <div id="bergfuehrer" class="bergfuehrer container">
    <img class="icon-img" width="100px" src="../../assets/icons/noun_Carabiner_45153(1).png"/>
    <h3 class="title"><b>Bergführer</b> </h3>
    <div class="members-grid members-grid-four">
      @for (i of [0,1,2,3]; track i) {
        <div class="members-grid-item">
          <app-member [member]="members[i]"></app-member>
        </div>
      }
    </div>
  </div>
  <div class="decorator"></div>
  <div class="background-img-snow"></div>
  <div class="decorator"></div>
  <div id="bergwanderfuehrer" class="bergwanderfuehrer container">
    <img class="icon-img" width="100px" src="../../assets/icons/noun_Mountain Climbing_45240(2).png"/>
    <h3 class="title">Bergwanderführer</h3>
    <div class="members-grid members-grid-three">
      @for (i of [4,5,6]; track i) {
        <div class="members-grid-item">
          <app-member [member]="members[i]"></app-member>
        </div>
      }
    </div>
  </div>
  <div class="decorator"></div>
  <div [style]="{marginBottom: '3rem'}" class="container galleria">
    <app-gallery></app-gallery>
  </div>
  <div class="decorator"></div>
  <div class="background-img"></div>
  <div class="offers">
    <h2 class="offers-title">Unser Angebot <i style="color: red" class="fas fa-heart"></i></h2>
    <div class="offers-list">
      <ul class="fa-ul">
        @for (offer of offers; track offer) {
          <li class="list-element"><span class="fa-li"><i class="fas fa-mountain"></i></span>{{offer}}</li>
        }
      </ul>
    </div>
  </div>
  <div class="decorator"></div>
</div>
